const OBTENER_BUSQUEDA_INSCRIPCIONES_COLEGIO =
  "extragestor/inscripciones/OBTENER_BUSQUEDA_INSCRIPCIONES_COLEGIO";
const LIMPIAR_BUSQUEDA_INSCRIPCIONES_COLEGIO =
  "extragestor/inscripciones/LIMPIAR_BUSQUEDA_INSCRIPCIONES_COLEGIO";
const BUSQUEDA_COLEGIOS_INSCRIPCIONES =
  "extragestor/inscripciones/BUSQUEDA_COLEGIOS_INSCRIPCIONES";
const INSCRIBIR_EN_COLEGIO = "extragestor/inscripciones/INSCRIBIR_EN_COLEGIO";
const RESET_INSCRIBIR_EN_COLEGIO =
  "extragestor/inscripciones/RESET_INSCRIBIR_EN_COLEGIO";
const OBTENER_DETALLE_COLEGIO =
  "extragestor/inscripciones/OBTENER_DETALLE_COLEGIO";
const LIMPIAR_DETALLE_COLEGIO =
  "extragestor/inscripciones/LIMPIAR_DETALLE_COLEGIO";
const DATA_SAVED = "extragestor/inscripciones/DATA_SAVED";
const RESET_DATA_SAVED = "extragestor/inscripciones/RESET_DATA_SAVED";

/*---*/
export {
  OBTENER_BUSQUEDA_INSCRIPCIONES_COLEGIO,
  LIMPIAR_BUSQUEDA_INSCRIPCIONES_COLEGIO,
  BUSQUEDA_COLEGIOS_INSCRIPCIONES,
  INSCRIBIR_EN_COLEGIO,
  RESET_INSCRIBIR_EN_COLEGIO,
  OBTENER_DETALLE_COLEGIO,
  LIMPIAR_DETALLE_COLEGIO,
  DATA_SAVED,
  RESET_DATA_SAVED
};



// WEBPACK FOOTER //
// ./src/ducks/inscripciones/types.js